import { CheckoutAddShippingInfoApplicationEvent 
} from '~shared/modules/application-event/models/checkout-add-shipping-info-event.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';
export class GaTrackingAddShippingInfoEventModel implements GATrackingEvent{
  constructor(private checkoutAddShippingInfoApplicationEventPayload: CheckoutAddShippingInfoApplicationEvent) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.AddShippingInfo;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: this.getEventType(),
      gtmCustom: {
        ...this.checkoutAddShippingInfoApplicationEventPayload
      }
    };
  }
}
